import { HttpRequest, HttpInterceptor, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';

import { map, catchError } from 'rxjs/operators';
import { ToastrManager } from 'ng6-toastr-notifications';
import { LanguageService } from './language.service';
import { Router, ActivatedRoute, UrlTree, UrlSegmentGroup, UrlSegment, PRIMARY_OUTLET } from '@angular/router';
import { AuthService } from './auth.service';


@Injectable()
export class AddHeaderInterceptor implements HttpInterceptor {
  constructor(private toastrManager: ToastrManager, private languageService: LanguageService
    ,private router: Router
    ,private authService:AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Clone the request to add the new header
    const clonedRequest = req.clone({ headers: req.headers.set('Authorization', 'Bearer ' + localStorage.getItem("auth_token")).set('Access-Control-Allow-Origin','*') });

    // Pass the cloned request instead of the original request to the next handle
    return next.handle(clonedRequest).pipe(map((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        // console.log('event--->>>', event);
        // this.errorDialogService.openDialog(event);
      }
      return event;
    }),
      catchError((error: HttpErrorResponse) => {
        let data = {};
        data = {
          reason: error && error.error && error.error.reason ? error.error.reason : '',
          status: error.status
        };
        // console.log(data)
        var message = "";

        const tree: UrlTree = this.router.parseUrl(this.router.url);
        const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
        const s: UrlSegment[] = g.segments;
        console.info("err=>",error.error);
        switch (error.status) {
          case 401:
            // this.authService.signOutSite();
            localStorage.removeItem('auth_token');
            if (s[0].path != "login") {
              window.location.href = "auth/login";
            }
            message = this.languageService.translate('errorLogin');
            break;
          case 500:
            message = this.languageService.translate('error500');
            break;
          case 400:
            if (s[0].path == "login") {
              message = this.languageService.translate('errorUserNameOrPassword')
            }else {
              message = this.languageService.translate('error')
            }
            break;
          default:
            message = this.languageService.translate('error')
            break;
        }
        var errors = error.error as [];
        this.toastrManager.errorToastr(errors + "");

        return throwError("");
      }));
  }


}
